
<template class="">
  <div class="flex items-center justify-center min-h-screen">
    <div class="bg-white items-center justify-center">
      <div class="space-y-8">
        <div class="space-y-4 mb-8">
          <h2 class="text-3xl font-bold mb-6 text-left text-bodyText">
            Reset Password
          </h2>
          <p class="text-[14px] w-[411px] text-grayDark">
            Enter the code you received in your email and set your new password
          </p>
        </div>
        <form @submit.prevent="resetPassword">
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">Email</label>
            <input
              v-model="email"
              type="email"
              placeholder="Enter your email address"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
              :disabled="isLoading"
            />
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700"
              >Reset Code</label
            >
            <input
              v-model="code"
              type="text"
              placeholder="Enter the 6-digit code"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
              maxlength="6"
              :disabled="isLoading"
            />
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700"
              >New Password</label
            >
            <div class="relative">
              <input
                v-model="newPassword"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Enter your new password"
                class="mt-1 block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                required
                :disabled="isLoading"
              />
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                <span @click="togglePassword" class="cursor-pointer">
                  <svg
                    v-if="!showPassword"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>view</title>
                    <g
                      stroke-linejoin="miter"
                      fill="#212121"
                      stroke-linecap="butt"
                      class="nc-icon-wrapper"
                    >
                      <path
                        d="M1.373,13.183a2.064,2.064,0,0,1,0-2.366C2.946,8.59,6.819,4,12,4s9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366C21.054,15.41,17.181,20,12,20S2.946,15.41,1.373,13.183Z"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <circle
                        data-color="color-2"
                        cx="12"
                        cy="12"
                        r="4"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></circle>
                    </g>
                  </svg>
                  <svg
                    v-else
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>view off</title>
                    <g
                      stroke-linejoin="miter"
                      fill="#212121"
                      stroke-linecap="butt"
                      class="nc-icon-wrapper"
                    >
                      <path
                        d="M3,3L21,21"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <path
                        d="M10.584,5.75A8.779,8.779,0,0,1,12,5.5c5.182,0,9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366,15.4,15.4,0,0,1-1.778,2.075"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <path
                        d="M6.982,6.982C3.919,8.944,2.127,11.756,1.373,13.183a2.064,2.064,0,0,0,0,2.366C2.946,17.776,6.819,22.366,12,22.366a9.158,9.158,0,0,0,4.018-.982"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <path
                        d="M8.465,8.465a3.993,3.993,0,0,0,7.07,7.07"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700"
              >Confirm New Password</label
            >
            <div class="relative">
              <input
                v-model="confirmPassword"
                :type="showConfirmPassword ? 'text' : 'password'"
                placeholder="Confirm your new password"
                class="mt-1 block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                required
                :disabled="isLoading"
              />
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                <span @click="toggleConfirmPassword" class="cursor-pointer">
                  <svg
                    v-if="!showConfirmPassword"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>view</title>
                    <g
                      stroke-linejoin="miter"
                      fill="#212121"
                      stroke-linecap="butt"
                      class="nc-icon-wrapper"
                    >
                      <path
                        d="M1.373,13.183a2.064,2.064,0,0,1,0-2.366C2.946,8.59,6.819,4,12,4s9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366C21.054,15.41,17.181,20,12,20S2.946,15.41,1.373,13.183Z"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <circle
                        data-color="color-2"
                        cx="12"
                        cy="12"
                        r="4"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></circle>
                    </g>
                  </svg>
                  <svg
                    v-else
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>view off</title>
                    <g
                      stroke-linejoin="miter"
                      fill="#212121"
                      stroke-linecap="butt"
                      class="nc-icon-wrapper"
                    >
                      <path
                        d="M3,3L21,21"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <path
                        d="M10.584,5.75A8.779,8.779,0,0,1,12,5.5c5.182,0,9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366,15.4,15.4,0,0,1-1.778,2.075"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <path
                        d="M6.982,6.982C3.919,8.944,2.127,11.756,1.373,13.183a2.064,2.064,0,0,0,0,2.366C2.946,17.776,6.819,22.366,12,22.366a9.158,9.158,0,0,0,4.018-.982"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <path
                        d="M8.465,8.465a3.993,3.993,0,0,0,7.07,7.07"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="w-full py-2 px-4 bg-primaryDarkBg hover:bg-primaryDark text-white font-bold rounded disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="isLoading"
          >
            <span v-if="!isLoading">Reset Password</span>
            <span v-else>Resetting...</span>
          </button>
        </form>
      </div>

      <div>
        <hr class="w-full border-t-[1px] border-grayLight mb-6" />
        <p class="mt-6 text-primaryDark flex justify-between items-center">
          Remember your password?
          <router-link
            to="/login"
            class="text-primaryDark hover:u px-3 py-3 bg-[#EEEEEE] rounded-md"
            >Log In</router-link
          >
        </p>
        <p class="mt-4 text-primaryDark flex justify-between items-center">
          Didn't receive a code?
          <router-link
            to="/forgot-password"
            class="text-primaryDark hover:u px-3 py-3 bg-[#EEEEEE] rounded-md"
            >Resend Code</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";

export default {
  name: "ResetPasswordComponent",
  data() {
    return {
      email: "",
      code: "",
      newPassword: "",
      confirmPassword: "",
      isLoading: false,
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  created() {
    if (this.$route.params.email) {
      this.email = this.$route.params.email;
    } else if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }

    if (this.$route.query.code) {
      this.code = this.$route.query.code;
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },

    async resetPassword() {
      if (!this.email) {
        this.$toast.error('Please enter your email address');
        return;
      }

      if (!this.code) {
        this.$toast.error('Please enter the reset code');
        return;
      }

      if (!this.newPassword) {
        this.$toast.error('Please enter your new password');
        return;
      }

      if (!this.confirmPassword) {
        this.$toast.error('Please confirm your new password');
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.$toast.error('Please enter a valid email address');
        return;
      }

      if (!/^\d{6}$/.test(this.code)) {
        this.$toast.error('Reset code must be 6 digits');
        return;
      }

      if (this.newPassword.length < 8) {
        this.$toast.error('Password must be at least 8 characters long');
        return;
      }

      if (this.newPassword !== this.confirmPassword) {
        this.$toast.error('Passwords do not match');
        return;
      }

      this.isLoading = true;

      try {
        const response = await apiClient.post("/web/reset_password", {
          email: this.email,
          code: this.code,
          new_password: this.newPassword,
        });

        if (response.data.status_code === 200) {
          this.$toast.success(response.data.message);
          this.email = "";
          this.code = "";
          this.newPassword = "";
          this.confirmPassword = "";

          setTimeout(() => {
            this.$router.push({
              name: "Login",
              query: {
                message:
                  "Password reset successfully. Please log in with your new password.",
              },
            });
          }, 3000);
        }
      } catch (error) {
        console.error("Error resetting password:", error);

        if (error.response && error.response.data && error.response.data.detail) {
          this.$toast.error(error.response.data.detail);
        } else if (error.response && error.response.data && error.response.data.message) {
          this.$toast.error(error.response.data.message);
        } else {
          this.$toast.error('An error occurred. Please try again later.');
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
    
<style scoped>
</style>

